var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"btn",attrs:{"type":_vm.type,"variant":"danger","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"d-flex align-items-center"},[_c('span',{staticClass:"icon-trash mr-1"}),_vm._v(" "+_vm._s(_vm.text || _vm.$t('delete'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }